module.exports = __webpack_public_path__ + "static/media/coffee_green_tea.37e8394c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/coffee_green_tea.png
 ** module id = 626
 ** module chunks = 0
 **/